
import {of as observableOf,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Route, PreloadingStrategy } from '@angular/router';


@Injectable()
export class SelectiveStrategy implements PreloadingStrategy {

    preload(route: Route, load: Function): Observable<any> {
        if (route.data && route.data['preload']) {
            return load();
        }
        return observableOf(null);
    }
}
